const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// ========================
// 🔹 REQUEST WRAPPER
// ========================
async function request(endpoint, options = {}) {
  const res = await fetch(`${BASE_URL}/api${endpoint}`, {
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
    ...options,
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(errorText || "API Error");
  }

  return res.json();
}

// ========================
// 🟢 API LÉGER'S COFFEE
// ========================
const api = {
  // ------------------------
  // PRODUCTS
  // ------------------------

  // GET /products — supporte les filtres optionnels
  // ex: getProducts({ featured: true, available: true, limit: 8 })
  getProducts: ({ featured, available, limit } = {}) => {
    const params = new URLSearchParams();
    if (featured !== undefined) params.append("featured", featured);
    if (available !== undefined) params.append("available", available);
    if (limit !== undefined) params.append("limit", limit);
    const qs = params.toString();
    return request(`/products${qs ? `?${qs}` : ""}`);
  },

  // GET /products/featured — ⚠️ doit rester AVANT getProductById dans server.py
  getFeaturedProducts: () => request("/products/featured"),

  // GET /products/:id
  getProductById: (id) => request(`/products/${id}`),

  // GET /products/by-slug/:slug — fetch + incrémente les vues
  getProductBySlug: (slug) => request(`/products/by-slug/${slug}`),

  // GET /products/by-slug/:slug/related
  getRelatedProducts: (slug) =>
    request(`/products/by-slug/${slug}/related`),

  getSuggestedProducts: (slug) => request(`/products/by-slug/${slug}/suggestions`),

  // No-op : les vues sont incrémentées par getProductBySlug directement
  // Conservé pour ne pas casser ProductPage.jsx
  incrementProductViews: () => Promise.resolve(null),

  // ------------------------
  // CATEGORIES
  // ------------------------
  getCategories: () => request("/categories"),

  // ------------------------
  // CONTACT
  // ------------------------
  sendContact: (data) =>
    request("/contact", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  getContacts: (adminToken) =>
    request("/contact", {
      headers: { "x-admin-token": adminToken },
    }),

  // ------------------------
  // RESERVATIONS
  // ------------------------
  createReservation: (data) =>
    request("/reservations", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  getReservations: (adminToken) =>
    request("/reservations", {
      headers: { "x-admin-token": adminToken },
    }),

  // ------------------------
  // CHECKOUT (STRIPE)
  // ------------------------
  createCheckoutSession: (data) =>
    request("/checkout/create-session", {
      method: "POST",
      body: JSON.stringify(data),
    }),

  // ------------------------
  // ADMIN — ORDERS
  // ------------------------
  getOrders: (adminToken) =>
    request("/orders", {
      headers: { "x-admin-token": adminToken },
    }),

  // ------------------------
  // HEALTH
  // ------------------------
  health: () => request("/health"),
  healthDb: () => request("/health/db"),
};

export default api;